import { ReactNode } from 'react';
import { Box, Typography } from '@material-ui/core';
import * as Styles from './Orders.css';

// Long free text (subject, conditions) under its label.
export const TextBlock = ({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) => (
  <Box mt={2}>
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Styles.Conditions>{value}</Styles.Conditions>
  </Box>
);

// One labelled value of an order's detail grid.
export const Field = ({
  label,
  value,
}: {
  label: string;
  value?: ReactNode;
}) => (
  <Styles.DetailItem>
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Typography component="div">{value || '—'}</Typography>
  </Styles.DetailItem>
);
